import React, { useEffect, useState } from 'react';
import Loading from '../../components/Loading/loading';
import LoginUser from '../../components/Login';

const Login = () => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {loading ? <Loading /> : <LoginUser setLoading={setLoading} />}
    </>
  );
};

export default Login;
